import { HolderOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Card } from 'antd';
import clx from 'classnames';
import type * as React from 'react';
import styled from 'styled-components';
import { FlexRow } from '../../../row/FlexRow.tsx';

const ContainerWrapper = styled.div`
  &.active {
    > .ant-card {
      z-index: 100;
      box-shadow: ${props => props.theme.boxShadow};
    }
  }
`;

const RowContainerCard = styled(Card)`
  .ant-card-body {
    padding: 0;
  }
`;
const HolderWrapper = styled.div`
  font-size: 18px;
  width: 18px;
  height: 24px;
  margin: 0 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colorBorder};
  border-radius: ${props => props.theme.borderRadius}px;
  cursor: grab;
  &:hover {
    color: ${props => props.theme.colorText};
    background-color: ${props => props.theme.colorBgContainerDisabled};
  }
`;
const RowContainerContentWrapper = styled.div`
  padding: 4px 8px;
  padding-top: 0;
  padding-right: 0;
  border-left: 1px solid ${props => props.theme.colorSplit};
`;

export interface IColumnPickerRowContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {
  holderProps?: React.HTMLAttributes<HTMLDivElement>;
  id: string | undefined;
}

/**
 * Componente che permette di gestire il DnD degli item del ColumnPicker
 * in fase di configurazione
 */
export function ColumnPickerRowContainer(
  props: IColumnPickerRowContainerProps,
) {
  const { children, holderProps, id, ...containerProps } = props;
  const { attributes, listeners, setNodeRef, transform, transition, active } =
    useSortable({ id: id! });

  return (
    <ContainerWrapper className={clx({ active: active?.id === id })}>
      <RowContainerCard
        {...containerProps}
        ref={setNodeRef}
        style={{
          transform: CSS.Translate.toString(transform),
          transition,
        }}
        {...attributes}
      >
        <FlexRow
          align="center"
          left={
            <HolderWrapper {...holderProps} {...listeners}>
              <HolderOutlined aria-hidden />
            </HolderWrapper>
          }
        >
          <RowContainerContentWrapper>{children}</RowContainerContentWrapper>
        </FlexRow>
      </RowContainerCard>
    </ContainerWrapper>
  );
}
